import React from 'react'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import { Parallax } from 'react-spring/addons.cjs'

// Components
import Layout from '../components/Layout'
import ProjectCard from '../components/ProjectCard'

// Elements
import { Title, BigTitle, Subtitle } from '../elements/Titles'

// Views
import Hero from '../views/Hero'
import Projects from '../views/Projects'
import About from '../views/About'
import Contact from '../views/Contact'

import Header from '../components/Header';

import avatar from '../../static/log.png'

const ProjectsWrapper = styled.div`
  ${tw`flex flex-wrap justify-between mt-8`};
  display: grid;
  grid-gap: 4rem;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: 1200px) {
    grid-gap: 3rem;
  }
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
`

const AboutHero = styled.div`
  ${tw`flex flex-col lg:flex-row items-center mt-8`};
`

const Avatar = styled.img`
  ${tw`rounded-full w-32 xl:w-48 shadow-lg h-auto`};
`

const AboutSub = styled.span`
  ${tw`text-white pt-12 lg:pt-0 lg:pl-12 text-2xl lg:text-3xl xl:text-4xl`};
`

const AboutDesc = styled.p`
  ${tw`text-grey-light text-lg md:text-xl lg:text-2xl font-sans pt-6 md:pt-12 text-justify`};
`

const Footer = styled.footer`
  ${tw`text-center text-grey absolute pin-b p-6 font-sans`};
`

const Index = () => (
  <>
    <Layout />
    <Parallax pages={5}>
      <Hero offset={0}>
        <BigTitle>
      <img src ="/log.png" alt="KDE Connect Logo"></img>KDE Connect
        </BigTitle>
        <Subtitle>KDE Connect adds communication between your desktop and your smartphone.</Subtitle>
      </Hero>
      <Projects offset={1}>
        <Title>Check Out</Title>
        <ProjectsWrapper>
          <ProjectCard
            title="Plugins"
            link="/plugins"
            bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)"
          >
            Enhancements for KDE Connect
          </ProjectCard>
          <ProjectCard
            title="Documentation"
            link="https://community.kde.org/KDEConnect"
            bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)"
          >
            A peek under the hood
          </ProjectCard>
          <ProjectCard
            title="Team"
            link="/team"
            bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)"
          >
            Meet the brains behind KDE Connect
          </ProjectCard>
          <ProjectCard
            title="Conribute"
            link="https://community.kde.org/KDEConnect#Development"
            bg="linear-gradient(to right, #D585FF 0%, #0000EE 100%)"
          >
            Set sail for Adventure!
          </ProjectCard>
        </ProjectsWrapper>
      </Projects>
      <About offset={3}>
        <Title>KDE Connect</Title>
        <AboutHero>
          <Avatar src={avatar} alt="John Doe" />
          <AboutSub>
          KDE Connect provides a set of features to integrate your workflow across devices:<br></br>
          </AboutSub>
        </AboutHero>
        <AboutDesc>
          {/* REFERENCE :  https://play.google.com/store/apps/details?id=org.kde.kdeconnect_tp */}
        <ul> 
<li>Shared clipboard: copy and paste between your devices.</li>
<li>Share files and URLs to your computer from any app, without wires.</li>
<li>Virtual touchpad: Use your phone screen as your computer's touchpad.</li>
<li>Notifications sync: Read your Android notifications from the desktop.</li>
<li>Multimedia remote control: Use your phone as a remote for Linux media players.</li>
<li>WiFi connection: no USB wire or bluetooth needed.</li>
<li>End-to-end TLS encryption: your information is safe.</li>
</ul>
<br></br>
<p align ="center">Please note you will need to install KDE Connect on your computer for this app to work, and keep the desktop version up-to-date with the Android version for the latest features to work.<br></br></p>

        </AboutDesc>
      </About>
      <Contact offset={4}>
        <Footer>
          
<p align ="center">This app is part of an open source project and it exists thanks to all the people who contributed to it. <br></br>Visit <a href="https://invent.kde.org/kde">the website</a> to grab the source code.<br></br></p>
          &copy; 2019 by Gatsby Starter Portfolio Cara.{' '}
          <a href="https://github.com/LekoArts/gatsby-starter-portfolio-cara">Github Repository</a>. Made by{' '}
          <a href="https://www.lekoarts.de">LekoArts</a>.
        </Footer>
      </Contact>
    </Parallax>
  </>
)

export default Index
